import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const links = [
  { label: 'Support', to: '/support' },
  { label: 'Terms', to: '/terms' },
  { label: 'Privacy', to: '/privacy' },
];

export default function Footer() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <footer className="w-full border-t border-white/[0.06] bg-[#070908] py-8">
      <div className="container mx-auto flex flex-col items-center gap-4 px-4">
        <nav
          aria-label="Footer navigation"
          className="flex flex-wrap items-center justify-center gap-6 text-sm font-medium text-gray-500"
        >
          {!isHome && (
            <Link
              to="/"
              className="transition-colors duration-200 hover:text-white"
            >
              Home
            </Link>
          )}
          {links.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`transition-colors duration-200 hover:text-white ${
                location.pathname === link.to ? 'text-[#ccff00]' : ''
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <p className="text-xs text-gray-700">
          © {new Date().getFullYear()} Paddle Up. All rights reserved.
        </p>
      </div>
    </footer>
  );
}